<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.orderCode" clearable placeholder="工单编号" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.taskState" clearable placeholder="状态" style="width:120px">
        <el-option label="待开工" value="00" />
        <el-option label="进行中" value="01" />
        <el-option label="已完成" value="02" />
        <el-option label="已取消" value="03" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button @click="checkConflicts">冲突检查</el-button>
      <el-button @click="checkChangeover">换型检查</el-button>
      <el-button type="primary" @click="openAuto">自动排程</el-button>
    </div>

    <el-alert
      v-if="conflicts.length"
      :title="'发现 ' + conflicts.length + ' 条冲突任务（同工序或同工单时间重叠）'"
      type="warning"
      show-icon
      :closable="false"
      style="margin-bottom:12px"
    />
    <el-alert
      v-if="changeoverGaps.length"
      :title="'发现 ' + changeoverGaps.length + ' 条换型间隙不足（同产线相邻不同产品）'"
      type="error"
      show-icon
      :closable="false"
      style="margin-bottom:12px"
    />
    <el-table v-if="changeoverGaps.length" :data="changeoverGaps" border size="small" style="margin-bottom:12px">
      <el-table-column prop="productionLineName" label="产线" width="120" />
      <el-table-column prop="prevOrderCode" label="前工单" width="130" />
      <el-table-column prop="prevProductNumber" label="前产品" width="120" />
      <el-table-column prop="nextOrderCode" label="后工单" width="130" />
      <el-table-column prop="nextProductNumber" label="后产品" width="120" />
      <el-table-column prop="gapMin" label="间隙分" width="90" align="right" />
      <el-table-column prop="requiredMin" label="需换型分" width="100" align="right" />
      <el-table-column prop="shortfallMin" label="缺口分" width="90" align="right" />
    </el-table>

    <el-table :data="list" border v-loading="loading" :row-class-name="rowClass">
      <el-table-column prop="taskCode" label="任务号" min-width="150" show-overflow-tooltip/>
      <el-table-column prop="orderCode" label="工单" min-width="130" show-overflow-tooltip/>
      <el-table-column prop="operationName" label="工序" min-width="140" show-overflow-tooltip/>
      <el-table-column prop="plannedQty" label="计划量" width="90" align="right" />
      <el-table-column prop="planStart" label="计划开始" width="170" />
      <el-table-column prop="planEnd" label="计划结束" width="170" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">{{ stateLabel(row.taskState) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="{ row }">
          <el-button v-if="row.taskState !== '03'" type="text" @click="editRow(row)">调程</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog title="调整排程" :visible.sync="editVisible" width="480px" :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item label="任务">{{ editForm.taskCode }}</el-form-item>
        <el-form-item label="开始">
          <el-date-picker v-model="editForm.planStart" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
        </el-form-item>
        <el-form-item label="结束">
          <el-date-picker v-model="editForm.planEnd" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" @click="saveEdit">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="工单自动排程" :visible.sync="autoVisible" width="480px" :close-on-click-modal="false">
      <el-form label-width="110px">
        <el-form-item label="工单">
          <el-select v-model="autoOrderId" filterable clearable style="width:100%">
            <el-option
              v-for="item in orderOptions"
              :key="item.orderId"
              :label="(item.orderCode || '') + ' / ' + (item.orderName || '')"
              :value="item.orderId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="每工序小时">
          <el-input-number v-model="hoursPerOp" :min="1" :max="72" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="autoVisible = false">取消</el-button>
        <el-button type="primary" @click="doAuto">执行</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listScheduleTasks, updateSchedule, findScheduleConflicts, autoScheduleOrder } from '../../api/schedule'
import { selectProductionOrder } from '../../api/productionOrder'
import { checkChangeoverSchedule } from '../../api/lineChangeoverNorm'

const STATE_MAP = { '00': '待开工', '01': '进行中', '02': '已完成', '03': '已取消' }

export default {
  name: 'SchedulePage',
  components: { ListPagination },
  data() {
    return {
      query: { orderCode: '', taskState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      conflicts: [], conflictIds: {}, changeoverGaps: [],
      editVisible: false, editForm: {},
      autoVisible: false, autoOrderId: '', hoursPerOp: 8, orderOptions: []
    }
  },
  created() { this.load() },
  methods: {
    stateLabel(s) { return STATE_MAP[s] || s || '-' },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listScheduleTasks({
        currentPage: this.page, pageSize: this.pageSize,
        orderCode: this.query.orderCode, taskState: this.query.taskState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    checkConflicts() {
      findScheduleConflicts({ orderCode: this.query.orderCode }).then(res => {
        this.conflicts = res.data || []
        const ids = {}
        this.conflicts.forEach(c => { ids[c.taskId] = true })
        this.conflictIds = ids
        if (!this.conflicts.length) this.$message.success('未发现冲突')
      })
    },
    checkChangeover() {
      checkChangeoverSchedule().then(res => {
        this.changeoverGaps = res.data || []
        if (!this.changeoverGaps.length) this.$message.success('换型间隙充足')
      })
    },
    rowClass({ row }) {
      return this.conflictIds[row.taskId] ? 'conflict-row' : ''
    },
    editRow(row) {
      this.editForm = {
        taskId: row.taskId,
        taskCode: row.taskCode,
        version: row.version,
        planStart: row.planStart,
        planEnd: row.planEnd
      }
      this.editVisible = true
    },
    saveEdit() {
      updateSchedule(this.editForm).then(() => {
        this.$message.success('已保存')
        this.editVisible = false
        this.load()
        this.checkConflicts()
      })
    },
    openAuto() {
      this.autoOrderId = ''
      this.hoursPerOp = 8
      this.autoVisible = true
      selectProductionOrder().then(res => { this.orderOptions = res.data || [] }).catch(() => { this.orderOptions = [] })
    },
    doAuto() {
      if (!this.autoOrderId) { this.$message.warning('请选择工单'); return }
      autoScheduleOrder(this.autoOrderId, this.hoursPerOp).then(() => {
        this.$message.success('自动排程完成')
        this.autoVisible = false
        this.load()
        this.checkConflicts()
      })
    }
  }
}
</script>

<style>
.conflict-row { background: #fdf6ec !important; }
</style>
